export const ASSERT_OK = 'ASSERT_OK';
export const ASSERT_STATUS_CODE = 'ASSERT_STATUS_CODE';

export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';

export const BANK_PREFIX_LENGTH = 6;
export const BANK_MAIN_LENGTH = 10;
export const BANK_CODE_LENGTH = 4;
